import { render, staticRenderFns } from "./passwordForm.vue?vue&type=template&id=0a95efef&"
import script from "./passwordForm.vue?vue&type=script&lang=js&"
export * from "./passwordForm.vue?vue&type=script&lang=js&"
import style0 from "./passwordForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "passwordForm.vue"
export default component.exports